<template>
    <div class="MMyQuestion" v-if="init">
        <pull :pull="pull" :page="page" @getList="getList">
            <NoData v-if="!dataList.length"></NoData>
            <div class="question_bank_warp">
                <div @click="handQuestionClick(item)" v-for="(item, index) in dataList" :key="index" class="question_item_box">
                    <img :src="item.coverurl" alt="">
                    <div class="van-multi-ellipsis--l2 title_box">{{item.subject}}</div>
                </div>
            </div>
        </pull>
    </div>
</template>

<script>
import {getAllQuestionbankByUser} from 'api/examApi'
import {mapGetters, mapActions} from 'vuex'
import NoData from 'views/mobile/components/noData/noData'
import Pull from 'views/mobile/components/pull/pull'
export default {
    name: 'MMyQuestion',
    data() {
        return {
            // testImg: 'http://innertest.img.capwhale.com/kmc/content/20200211/4ac47838ea9b41219d765b65e23241c4',
            init: false,
            dataList: [],
            param: {},
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            }
        }
    },
    mounted() {
        this.setNoDataTip('暂无题库')
        if (!this.refresh) {
            this.getList()
        }
    },
    activated () {
        if (this.refresh) {
            this.getList()
            this.setRefresh(false)
        }
    },
    methods: {
        // 点击我的题库列表单个题库跳转到题库详情页面
        handQuestionClick(val) {
            // console.log(val)
            this.setRefresh(true)
            this.$router.push({name: 'PaperDetails',query: {qid: val.bankid}})
        },
        // 获取题库列表
        getList() {
            this.setLoading(true)
            getAllQuestionbankByUser({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.init = TextTrackCueList
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.dataList = data.data.content
                    } else {
                        this.dataList = this.dataList.concat(data.data.content)
                    }
                    this.setLoading(false)
                    this.pull.loading = false
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.page.rowCount = data.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setRefresh',
            'setNoDataTip'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['refresh'])
    },
    components: {
        NoData,
        Pull
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
        opacity: 0
    }
    .MMyQuestion {
        font-family:PingFangSC-Regular,PingFang SC;
        background:rgba(245,247,250,1);
        min-height: 100vh;
        color: #333;
        .noData{
            height: 100vh;
            background: #fff;
        }
        .question_bank_warp {
            background:rgba(255,255,255,1);
            padding: 0 0.32rem;
            .question_item_box {
                padding: 0.32rem 0;
                display: flex;
                border-bottom: 0.01rem solid #E5E5E5;
                &>img {
                    width:2.6rem;
                    height:1.45rem;
                    border-radius:0.04rem;
                    margin-right: 0.18rem;
                }
                .title_box {
                    flex: 1;
                    font-size: 0.28rem;
                    height: 0.8rem;
                    line-height: 0.4rem;
                    text-align: justify;
                }
            }
            .question_item_box:nth-last-of-type(1) {
                border-bottom: none;
            }
        }
    }
</style>